const SiteName = "From Dusk 'Til Dawn";

export { SiteName };
